import script from "./MainMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainMobile.vue?vue&type=script&lang=ts&setup=true"

import "./MainMobile.vue?vue&type=style&index=0&id=b1618992&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1618992"]])

export default __exports__